import deepExtend from 'deep-extend';
import CookieHelper from '../../utils/cookie';

class UserContextStorage {
    constructor() {
        this.update();
    }

    enabled() {
        return CookieHelper.has('cq-opt-in');
    }

    setData(sourceObject) {
        if (this.enabled()) {
            if (!localStorage.getItem('userContextData')) {
                localStorage.setItem('userContextData', JSON.stringify({}));
            }

            const targetObject = JSON.parse(localStorage.getItem('userContextData'));
            deepExtend(targetObject, sourceObject);

            localStorage.setItem('userContextData', JSON.stringify(targetObject));
        }
    }

    update() {
        if (this.enabled()) {
            this.setLastViewed();
        }
    }

    setLastViewed() {
        const parts = window.location.pathname.split('/');
        if (parts.includes('cars') && parts.includes('new')) {
            const index = parts.indexOf('new');
            const model = parts[index + 1];
            if (model) {
                this.setData({
                    cars: {
                        lastActivity: {
                            viewed: model,
                        },
                        modelActivity: {
                            [model]: {
                                viewed: true,
                            },
                        },
                    },
                });
            }
        }
    }
}

window.HONDA = window.HONDA || {};
window.HONDA.UserContext = new UserContextStorage();
